import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen/HomeScreen";
import Error404 from "./screens/Error404/Error404";
import ProjectsScreen from "./screens/ProjectsScreen/ProjectsScreen";
import ProjectScreen from "./screens/ProjectScreen/ProjectScreen";
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="*" element={<Error404 />} />
          <Route path="/projects" element={<ProjectsScreen />} />
          <Route path="/project/:id" element={<ProjectScreen />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
